import { useEffect, useRef } from "react"
import { executeScripts } from "./utils"

function ExecuteScripts({ html }) {
  const elRef = useRef(null)

  useEffect(() => {
    return executeScripts(elRef.current)
  }, [])

  return <div ref={elRef} dangerouslySetInnerHTML={{ __html: html }} />
}

ExecuteScripts.displayName = "ExecuteScripts"

export default ExecuteScripts
